const STRAIT_VALUE_NAME = '~';

export default class StringUtilities {
    static stringifyValue (value: any) {
        if(value === undefined || value === null) return '';

        let obj: Record<string, any> = {};
        if (value instanceof Date) {
            obj = { [STRAIT_VALUE_NAME]: value.toISOString() };
        } else if (typeof value === 'object') {
            obj = value;
        } else {
            obj = { [STRAIT_VALUE_NAME]: value };
        }

        return btoa(encodeURIComponent(JSON.stringify(obj)));
    }

    static parseValue(value: string) {
        if(!value) return '';
        const paresValue = JSON.parse(decodeURIComponent(atob(value)));
        return paresValue[STRAIT_VALUE_NAME] || paresValue;
    }
}
